import { render, staticRenderFns } from "./IviewSelect.vue?vue&type=template&id=2f0e25cd&scoped=true&"
import script from "./IviewSelect.vue?vue&type=script&lang=js&"
export * from "./IviewSelect.vue?vue&type=script&lang=js&"
import style0 from "./IviewSelect.vue?vue&type=style&index=0&id=2f0e25cd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e25cd",
  null
  
)

export default component.exports